// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"base-info_infoWrap_1y1EC","height":"base-info_height_2R-5p"};